var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 69.3994,
    height: 69.3994,
    rx: 34.6997,
    fill: "#DC4649"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_66_193254)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3651 44.069C41.6677 39.629 46.3279 30.2718 46.1444 24.5841C46.0727 22.0031 44.9925 19.5529 43.1355 17.7589C41.2014 15.6061 38.63 14.1275 35.7965 13.539C34.2783 13.3818 32.7441 13.542 31.2912 14.0095C29.8382 14.477 28.4984 15.2415 27.3567 16.2544C24.8473 18.1339 23.1848 20.9312 22.7332 24.0337C22.4802 28.3007 23.5158 32.5453 25.7054 36.2164L30.5125 43.5553C31.0532 44.5332 31.6537 45.4768 32.3105 46.3808C32.4507 46.5622 32.628 46.7116 32.8304 46.8192C33.0329 46.9268 33.2559 46.99 33.4847 47.0046C33.7735 46.986 34.0444 46.8579 34.2421 46.6466C34.4398 46.4352 34.5495 46.1565 34.5489 45.8671C34.5489 44.2158 32.7875 42.6746 32.6408 42.1976L28.4576 35.0421C27.1396 32.3564 26.4376 29.4104 26.4026 26.4189C26.6595 14.4564 41.7044 16.5113 42.4749 24.8777C42.9887 30.1617 38.3651 39.5556 36.3102 42.748C36.1232 43.0166 36.0492 43.3478 36.1041 43.6704C36.159 43.993 36.3384 44.2811 36.6038 44.4727C36.7447 44.5659 36.9031 44.6296 37.0693 44.6598C37.2356 44.69 37.4063 44.6861 37.571 44.6483C37.7357 44.6106 37.891 44.5398 38.0275 44.4402C38.164 44.3406 38.2789 44.2143 38.3651 44.069Z",
    fill: "#FFF4E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6686 22.7489C31.0633 22.4553 28.7148 27.5926 32.0908 29.2806C34.586 30.5282 35.5401 29.2806 36.4941 28.0696C36.8685 27.563 37.092 26.9607 37.1386 26.3324C37.1852 25.7041 37.0532 25.0755 36.7577 24.5191C36.4622 23.9627 36.0154 23.5012 35.4688 23.1879C34.9222 22.8747 34.2981 22.7225 33.6686 22.7489Z",
    fill: "#FFF4E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.8417 50.4676C48.64 49.9545 49.5574 52.8825 46.0347 57.1085C44.8238 57.3801 24.5316 58.4064 23.8344 57.5612C22.2395 55.2908 20.8416 52.9304 19.6512 50.4978C19.5289 50.303 19.3248 50.1513 19.0768 50.0709C18.8289 49.9905 18.5539 49.9868 18.3029 50.0606C18.0518 50.1343 17.8419 50.2805 17.7119 50.4719C17.582 50.6633 17.5409 50.8871 17.5963 51.1015C18.5137 53.6371 20.5686 59.6139 22.4767 60.1572C29.1551 62.2702 46.3283 60.3685 48.163 59.4026C49.9978 58.4366 50.9518 54.3012 51.8325 51.6147C51.8596 51.3579 51.7748 51.1015 51.5933 50.8914C51.4118 50.6813 51.1454 50.5311 50.8417 50.4676Z",
    fill: "#FFF4E2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_66_193254"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53.0184,
    height: 53.0184,
    fill: "white",
    transform: "translate(8.19043 8.19043)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationicon);
export default __webpack_public_path__ + "static/media/locationicon.287b3b94fe63ebf0e26a03d0f27e586e.svg";
export { ForwardRef as ReactComponent };